import { useState, useContext, useEffect } from 'react';
import Sidebar from '../../../components/ConsumerSidebar/ConsumerSidebar';
import { Box, Container, AppBar, Toolbar, Typography } from '@mui/material';
import StyledButton from '../../../components/Button/Button';
import { getCardDetails } from '../../../services/NetworkServices';
import ApiStatus from '../../../config/apiStatusConstants';
import LeftArrow from '../../../assets/Left 1.svg';
import TemporaryDrawer from '../../../components/TemporaryDrawer/TemporaryDrawer';
import CardModal from '../../../components/CardModal/CardModal';
import Loader from '../../../components/Loader';
import {
  ProfileContext,
  ProfileContextProps,
} from '../../../context/ProfileContext';
import LogoutPopup from '../../../components/Inputs/LogoutPopup';

interface CardDetails {
  cardHolderName?: string;
  cardNumber?: number;
  cardExpiryDate?: string;
  cardType?: string;
}

function formatMonth(month: number): string {
  if (month < 10) {
    return `0${month}`;
  } else {
    return String(month);
  }
}

const AddCardDetails = () => {
  const { showLogoutPopup } = useContext(ProfileContext) as ProfileContextProps;
  const [openCardModal, setOpenCardModal] = useState(false);
  const [cardDetails, setCardDetails] = useState<CardDetails>({});
  const [apiStatus, setApiStatus] = useState<ApiStatus>(ApiStatus.INITIAL);

  useEffect(() => {
    const fetchCardDetails = async () => {
      setApiStatus(ApiStatus.LOADING);
      const response = await getCardDetails();
      const data = await response.data;
      if (data.status) {
        setApiStatus(ApiStatus.SUCCESS);
        setCardDetails({
          ...cardDetails,
          cardHolderName: data.data.paymentMethods.data[0].billing_details.name,
          cardNumber: data.data.paymentMethods.data[0].card.last4,
          cardType: data.data.paymentMethods.data[0].card.display_brand,
          cardExpiryDate: `${formatMonth(data.data.paymentMethods.data[0].card.exp_month)}/${String(data.data.paymentMethods.data[0].card.exp_year).slice(2)}`,
        });
      }
    };
    fetchCardDetails();
  }, [openCardModal]);

  const handleContinue = () => {
    setOpenCardModal(false);
  };
  return (
    <>
      {showLogoutPopup && <div className="backdrop"> </div>}
      <Box className={`editProfile ${showLogoutPopup ? 'popup-active' : ''}`}>
        <Box className="account-details" sx={{ height: 'auto' }}>
          <Box
            sx={{
              display: { xs: 'block', sm: 'flex' },
              height: { xs: '100vh', sm: '100vh' },
              overflow: { xs: 'auto', sm: 'hidden' },
            }}
          >
            {/* AppBar for xs devices */}
            <AppBar
              position="static"
              sx={{
                display: { xs: 'block', sm: 'none' },
                backgroundColor: 'black',
              }}
            >
              <Toolbar sx={{ background: 'black' }}>
                <TemporaryDrawer />
              </Toolbar>
            </AppBar>

            {/* Sidebar for sm and above */}
            <Box
              sx={{
                display: { xs: 'none', sm: 'flex' },
                width: { xs: '0%', sm: '35%', md: '28%' },
                justifyContent: 'space-between',
                flexDirection: 'column',
              }}
            >
              <Box
                sx={{
                  height: '100%',
                  marginLeft: { sm: 2, md: 14 },
                  marginTop: { sm: 2, md: 4 },
                  marginBottom: { sm: 30, md: 4 },
                }}
              >
                <Sidebar />
              </Box>
            </Box>

            {/* Main Content Area */}

            {!openCardModal && (
              <Box
                sx={{
                  width: { xs: '100%', sm: '65%', md: '72%' },
                  flexGrow: 1,
                  overflow: 'auto',
                  height: '100vh',
                  paddingY: 10,
                  display: 'flex',
                  flexDirection: 'column',
                }}
              >
                {apiStatus === ApiStatus.LOADING ? (
                  <Loader />
                ) : (
                  <Container>
                    {/* Back Arrow for xs devices */}
                    <Box sx={{ display: { xs: 'block', sm: 'none' } }}>
                      <img
                        src={LeftArrow}
                        //onClick={handleBackClick}
                        className="arrow-sm"
                      />
                    </Box>
                    <Box className="edit-profile-pic">
                      <Box
                        sx={{
                          display: 'flex',
                          flexDirection: 'column',
                          justifyContent: 'flex-start',
                          paddingTop: '20px',
                          width: { xs: '100%', sm: '100%', md: '60%' },
                        }}
                      >
                        <Box
                          sx={{
                            borderColor: '#365F91',
                            border: '1.4px solid transparent',
                            borderRadius: '35px',
                            background: `
                      linear-gradient(black, black) padding-box,
                      linear-gradient(180deg, #365f91 -4.29%, rgba(54, 95, 145, 0) 100%) border-box
                    `,
                            color: 'white',
                            width: { xs: '79vw', md: '39vw' },
                            height: '100px',
                            textAlign: 'left',
                            padding: '25px',
                            marginLeft: '20px',
                            position: 'relative',
                          }}
                        >
                          <Typography
                            sx={{
                              mb: '12px',
                              fontSize: '20px',
                              textTransform: 'capitalize',
                              fontWeight: 'Bold',
                            }}
                          >
                            {cardDetails.cardHolderName}
                          </Typography>
                          <Typography sx={{ mb: '12px', fontSize: '20px' }}>
                            • • • •&nbsp; • • • • &nbsp; • • • • &nbsp;
                            {cardDetails.cardNumber}
                          </Typography>
                          <Box
                            sx={{
                              display: 'flex',
                              flexDirection: 'row',
                              gap: '35px',
                              mb: '12px',
                            }}
                          >
                            <Box
                              sx={{
                                display: 'flex',
                                flexDirection: 'column',
                                gap: '10px',
                                color: '#585858',
                                minWidth: '35px',
                                flexShrink: 0,
                              }}
                            >
                              <Typography>Expiry Date</Typography>
                              <Typography
                                sx={{ color: 'white', fontSize: '20px' }}
                              >
                                {cardDetails.cardExpiryDate}
                              </Typography>
                            </Box>
                            <Box
                              sx={{
                                display: 'flex',
                                flexDirection: 'column',
                                gap: '10px',
                                color: '#585858',
                              }}
                            >
                              <Typography>CVV</Typography>
                              <Typography
                                sx={{ color: 'white', fontSize: '20px' }}
                              >
                                • • •
                              </Typography>
                            </Box>
                            <Box
                              sx={{
                                display: 'flex',
                                flexDirection: 'column',
                                gap: '10px',
                                color: '#585858',
                                paddingTop: '15px',
                                position: 'absolute',
                                right: '2vw',
                              }}
                            >
                              <Typography
                                sx={{
                                  fontFamily:
                                    '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif !important',
                                  fontWeight: '500 !important',
                                  fontSize: {
                                    xs: '15px !important',
                                    md: '22px !important',
                                  },
                                }}
                              >
                                {cardDetails.cardType?.toLocaleUpperCase()}
                              </Typography>
                            </Box>
                          </Box>
                        </Box>
                      </Box>
                    </Box>
                  </Container>
                )}
                <StyledButton
                  sx={{
                    width: { xs: '29vw', md: '13vw' },
                    marginTop: '18vh',
                    marginLeft: { xs: '54vw', md: '29vw' },
                  }}
                  onClick={() => setOpenCardModal(true)}
                >
                  Update Card
                </StyledButton>
              </Box>
            )}
            {openCardModal && (
              <Box sx={{ paddingLeft: '10px', marginTop: '45px' }}>
                <CardModal
                  handleContinue={handleContinue}
                  // open={openCardModal}
                  // onClose={() => {
                  //   setOpenCardModal(false);
                  //   //navigate('/')
                  // }}
                />
              </Box>
            )}
          </Box>
        </Box>
      </Box>
      {showLogoutPopup && <LogoutPopup />}
    </>
  );
};

export default AddCardDetails;
